import { GetServerSideProps } from 'next/types';

import { MAIN_CONTENT_ID } from '@/components/accessibility/SkipToMain';
import Layout from '@/components/layout/LayoutWrapper';
import SimplifiedSignup from '@/components/SimplifiedSignup';
import SpotifyFlow from '@/components/SimplifiedSignup/configs/Spotify/Flow';
import { SimplifiedSignupContextProvider } from '@/components/SimplifiedSignup/Context';
import { shapeConfigForParams } from '@/components/SimplifiedSignup/Context/utils';
import { InitRequest } from '@/hooks/store';
import type { InitialServerState } from '@/store';
import { resolveCheckoutSessionsEnabled } from '@/utils/experiments/resolveCheckoutSessionsEnabled';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

type Props = {
	initialState: InitialServerState | null;
	isCheckoutSessionsEnabled: boolean;
};

const LinkSpotifyAccount = ({ isCheckoutSessionsEnabled }: Props) => {
	return (
		<Layout title="Calm + Spotify Signup page" pageName={'link-with-spotify'}>
			<main id={MAIN_CONTENT_ID}>
				<SimplifiedSignupContextProvider
					flowConfig={SpotifyFlow}
					isCheckoutSessionsEnabled={isCheckoutSessionsEnabled}
				>
					<SimplifiedSignup />
				</SimplifiedSignupContextProvider>
			</main>
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps<Props> = async context => {
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.USER, InitRequest.PRICES],
		shapeConfigForParams(SpotifyFlow),
	);

	// Resolved server-side so the payment screen's first render already
	// knows the buyer's `www-checkout-sessions` bucket (see the enrollment
	// latch in PaymentElementsFormRefresh).
	const isCheckoutSessionsEnabled = await resolveCheckoutSessionsEnabled(initialState);

	return {
		props: {
			initialState,
			isCheckoutSessionsEnabled,
		},
	};
};

export default LinkSpotifyAccount;
